
import { Component, Input, Output, EventEmitter, OnInit, Pipe} from '@angular/core';
import { AmazingTimePickerService } from 'amazing-time-picker';

@Component({
  selector: 'time-type',
  templateUrl: './time-type.component.html',
  styleUrls: ['./time-type.component.css'],
  providers: [AmazingTimePickerService]
})
export class TimeTypeComponent implements OnInit{

  //self explanatory

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() is_mandt : boolean;
  @Input() userRes : string[];
  @Input() question_number : number;
  @Output() user_Resp = new EventEmitter<string[]>();
  @Input() indexOfRepeater : number;
  @Input() is_range : number;

  response : string;
  responseMax : string;

  constructor(private atp: AmazingTimePickerService){
  }

  ngOnInit(){
    // this.response = this.userRes[this.indexOfRepeater];
  }

  openTimePickerDialog(event) {
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe(time => {
      if(event.target.id == 'time'){
        this.response = time;
        let ele =  (<HTMLInputElement>document.getElementById("time"));
        if(ele){
          ele.value = time;
        }
        if(this.is_range){
          this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response + " - " + (this.responseMax!= undefined ? this.responseMax:'NA')]);
        }
        else
          this.user_Resp.emit([this.indexOfRepeater.toString(),this.question_number.toString(),this.response]);
      }
      else if(this.is_range && event.target.id == 'timeMax'){
        this.responseMax = time;
        let ele =  (<HTMLInputElement>document.getElementById("timeMax"));
        if(ele){
          ele.value = time;
        }
        this.user_Resp.emit([this.indexOfRepeater.toString(), this.question_number.toString(), this.response + " - " + this.responseMax]);
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/questions-type/time-type/time-type.component.ts